import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import LayoutWithAccountCard from '../../layout/Layout/layout-account-card'
import { carouselCurrentItemSelector } from '../../selectors'
import CardLessService from '../../services/cardless.service'
import AddIcon from 'custom/assets/common-icons/Add.svg'
import moment from 'moment'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { CARDLESS_CASH_KEYS } from '../../utils/translation-constants'
import NeoButton from '../../components/NeoButton/NeoButton'
import Pagination from 'react-js-pagination'
import NumberFormat from 'react-number-format'
import menuData from 'custom/config/feature.config.json'

export default function CardLessCash() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(1)
  const [tokenList, setTokenList] = useState([])
  const accountDetails = useSelector(carouselCurrentItemSelector) || {}
  const [noRecords, setNoRecords] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const [status, setStatus] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const [totalRecords, setTotalRecords] = useState(10)
  const { t } = useTranslation()
  const statusList = ['PENDING', 'ACCEPTED', 'REVERSED', 'CANCELLED', 'EXPIRED']

  const cardLessViewDetails = useCallback(
    async (page) => {
      try {
        setExpanded(null)
        setStage(0)
        let reqParams = {
          page: page,
          size: pageLimit,
          status: status || '',
        }
        const response = await CardLessService.cardlessViewToken(reqParams)
        if (response.status === 200) {
          setTokenList(response.data['tokens']['content'])
          setNoRecords(response.data['tokens']['content'].length === 0 ? true : false)
          setTotalRecords(response.data['totalItems'])
        }
        setStage(1)
      } catch (err) {
        setLoading(false)
        setStage(1)
      }
    },
    [accountDetails, status],
  )

  useEffect(() => {
    cardLessViewDetails(0)
  }, [])

  const paginationChange = useCallback(async (page) => {
    setCurrentPage(page)
    viewScheduledPaymentsList(page - 1)
  }, [])

  const handleCancelToken = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        let reqParams = {
          cif: selected.cif,
          accountNo: selected.sourceAccountNo,
          status: selected.status,
          token: selected.token,
        }
        const response = await CardLessService.cardlessCancelToken(reqParams)
        if (response.status === 200) {
          setLoading(false)
          toast(response.data['message'])
          cardLessViewDetails()
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [accountDetails],
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderCardLessViewForm()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderCardLessViewForm() {
    return (
      <>
        {noRecords && <div className='no-data-found'>{t(CARDLESS_CASH_KEYS.NO_RECORDS)} </div>}

        {tokenList.map((option, index) => (
          <>
            <div key={index} className='approval-card'>
              <div
                className='approval-card-header'
                onClick={async () => {
                  if (expanded == index) {
                    setExpanded(null)
                  } else {
                    setExpanded(index)
                  }
                }}>
                <span>
                  <span>
                    {t(CARDLESS_CASH_KEYS.TOKEN_NO)} : {option.token}
                  </span>
                  <span style={{ marginTop: 5 }}>
                    {' '}
                    {t(CARDLESS_CASH_KEYS.REFERENCE)} : {option.txnRefNo}
                  </span>
                </span>

                <span>
                  <span>
                    {t(CARDLESS_CASH_KEYS.EXPIRY_DATE)} :{' '}
                    {moment(option?.expiry).format('DD-MM-YYYY h:mm A')}
                  </span>
                  <span style={{ marginTop: 5 }}>
                    {' '}
                    {t(CARDLESS_CASH_KEYS.STATUS)} : {option.status}
                  </span>
                </span>
              </div>
              {expanded === index && (
                <div className='approval-card-body'>
                  <div className='row'>
                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.TOKEN_NO)}</label>
                      <span>{option?.token || '-'}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.ACCOUNT_NUMBER)}</label>
                      <span>{option?.sourceAccountNo || '-'}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.CUSTOMER_ID)}</label>
                      <span>{option?.cif || '-'}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.MOBILE_NO)}</label>
                      <span>{option?.mobileNumber || '-'}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.AMOUNT)}</label>
                      {/* <span>{option?.amount || '-'}</span> */}
                      <span className=''>
                        <NumberFormat
                          value={option?.amount}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          className='d-inline'
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </span>
                    </div>

                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.CREATE_DATE)}</label>
                      <span>{moment(option?.createdDate).format('DD-MM-YYYY h:mm A')}</span>
                    </div>

                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.EXPIRY_DATE)}</label>
                      <span>{moment(option?.expiry).format('DD-MM-YYYY h:mm A')}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARDLESS_CASH_KEYS.STATUS)}</label>
                      <span>{option.status}</span>
                    </div>
                  </div>
                  {menuData['CARDLESS_CASH']['CANCEL_TOKEN'] && (
                    <>
                      {(option.status === 'PENDING' || option.status === 'EXPIRED') && (
                        <div className='d-flex' style={{ marginTop: 20, justifyContent: 'center' }}>
                          {loading ? (
                            renderLoading()
                          ) : (
                            <a onClick={() => handleCancelToken(option)}>
                              {t(CARDLESS_CASH_KEYS.CANCEL_TOKEN)}
                            </a>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </>
        ))}
        <div className='d-flex justify-content-center mb-5 mt-2'>
          {!loading && tokenList?.length > 0 && (
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={pageLimit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={5}
              itemClass='page-item'
              linkClass='page-link'
              onChange={paginationChange}
            />
          )}
        </div>
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='ACCOUNT_CARDLESS_CASH'>
      <div className='row' style={{ marginBottom: 20 }}>
        <div className='col-7 d-flex'>
          <div className='heading-style' style={{ margin: 0, lineHeight: '40px' }}>
            {t(CARDLESS_CASH_KEYS.TITLE)}
          </div>
        </div>
        <div className='col-5 text-right'>
          <button
            onClick={() => history.push('/accounts/cardless-cash/generate')}
            type='button'
            className='btn p-2 detailed-statement-btn'>
            <img width={25} height={25} src={AddIcon} />
            <span style={{ marginLeft: 10 }} className='font-weight-600'>
              {t(CARDLESS_CASH_KEYS.GENERATE_TOKEN)}
            </span>
          </button>
        </div>
      </div>
      <div className='row col-12 align-center p-0 m-0 mb-3'>
        <label className='control-label col-2 text-center py-3'>
          {' '}
          {t(CARDLESS_CASH_KEYS.SEARCH_BY)}:
        </label>
        <div className='col-10 p-0 d-flex justify-content-between align-items-center'>
          <label className='control-label col-2'>{t(CARDLESS_CASH_KEYS.STATUS)} :</label>
          <select
            className={`form-control col-6`}
            value={status}
            onChange={(e) => setStatus(e.target.value)}>
            <option value='' disabled>
              {t(CARDLESS_CASH_KEYS.SELECT_STATUS)}
            </option>
            {statusList.map((item, i) => (
              <option key={i}>{item}</option>
            ))}
          </select>
          <div className='col-4'>
            <NeoButton
              onClick={() => cardLessViewDetails(0)}
              type='button'
              mode='newDesign'
              text={t(CARDLESS_CASH_KEYS.SEARCH)}
              mode='newDesign'
            />
          </div>
        </div>
      </div>
      {renderSwitch()}
    </LayoutWithAccountCard>
  )
}
